<!-- 快速采购 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
    </div>
    <!--    table    -->
    <div class="section-title">
      <div>商品明细</div>
      <div>
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click="showSearch()"
          v-if="type == 3 && permission.searchAP"
          >{{ permission.searchAP }}</el-button
        >
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click="showSubmitForm()"
          v-if="permission.submitOrder"
          >创建采购单</el-button
        >
      </div>
    </div>
    <div class="edit-ctn" v-if="type == 4">
      <!--      table title      -->
      <div class="div-table-row table-title">
        <div class="div-table-cell" style="width: 5%">
          <el-checkbox
            v-model="selectAll"
            @change="allSelectChange"
          ></el-checkbox>
          <el-checkbox-group v-model="selectList"></el-checkbox-group>
        </div>
        <div class="div-table-cell" style="width: 15%; flex-grow: 1">
          <span class="color-red">*</span>汽配编码
        </div>
        <div class="div-table-cell" style="width: 15%">
          <span class="color-red">*</span>配件名称
        </div>
        <div class="div-table-cell" style="width: 16%">
          <span class="color-red">*</span>车型
        </div>
        <div class="div-table-cell" style="width: 5%">
          <el-tooltip effect="dark" placement="bottom">
            <div slot="content">
              留余数=库存数-待出库数+待入库数<br />
              注意：这里不统计退货商品数量
            </div>
            <span>
              <i
                class="el-icon-warning-outline"
                style="color: orange; margin-right: 5px"
              ></i>
            </span>
          </el-tooltip>
          留余数
        </div>
        <div class="div-table-cell" style="width: 8%">数量</div>
        <div class="div-table-cell" style="width: 5%">单位</div>
        <div class="div-table-cell" style="width: 5%">销售价</div>
        <div class="div-table-cell" style="width: 8%">
          <span class="color-red">*</span>采购价
        </div>
        <div class="div-table-cell" style="width: 8%">采购总价</div>
        <div class="div-table-cell" style="width: 10%"></div>
      </div>
      <div class="table-main">
        <div
          class="div-table-row table-item"
          v-for="(item, index) in dataList"
          :ref="'pj' + index"
          :key="index"
        >
          <div class="div-table-cell" style="width: 5%">
            <el-checkbox
              v-model="item.checked"
              @change="selectSingleItemChange(item)"
            ></el-checkbox>
          </div>
          <!--        编码            -->
          <div
            class="div-table-cell div-table-cell-code"
            style="width: 15%; flex-grow: 1"
            :class="{ 'check-code-class': item.CodeRepeat }"
          >
            <img
              src="../../../assets/images/info.png"
              alt
              title="配件信息"
              class="info-icon"
              @click="showAPMsgDialog(item.EntpTempGoodsId)"
            />
            <el-select
              :ref="'code' + index"
              :disabled="type == 4"
              :loading="loading"
              allow-create
              default-first-option
              size="small"
              v-model="item.APCode"
              value-key="APCode"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="汽配编码"
              @change="codeChange($event, index)"
              @visible-change="apCodeVisibleChange($event)"
              :remote-method="searchCode"
              style="width: 100%"
            >
              <el-option
                v-for="optionItem in codeList"
                :key="optionItem.EntpTempGoodsId"
                :data-msg="optionItem"
                :label="optionItem.APCode"
                :value="optionItem.APCode"
              >
                <div class="option-content">
                  <div style="width: 200px">{{ optionItem.APCode }}</div>
                  <div style="width: 200px">{{ optionItem.GoodName }}</div>
                  <div>{{ optionItem.AutoSerise }}</div>
                </div>
              </el-option>
            </el-select>
            <div v-if="item.State==1" class="row-delete">已删除</div>
          </div>
          <!--        名称            -->
          <div class="div-table-cell" style="width: 15%">
            <el-input
              size="small"
              v-model="item.GoodName"
              v-if="item.IsNew"
              :disabled="type == 4"
              placeholder="配件名称"
            ></el-input>
            <el-select
              v-else
              :disabled="type == 4"
              :loading="loading"
              allow-create
              size="small"
              v-model="item.GoodName"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="配件名称"
              @change="nameChange($event, index)"
              @visible-change="apNameVisibleChange($event)"
              :remote-method="searchName"
              style="width: 100%"
            >
              <el-option
                v-for="optionItem in nameList"
                :key="optionItem.EntpTempGoodsId"
                :data-msg="optionItem"
                :label="optionItem.GoodName"
                :value="optionItem.GoodName"
              >
                <div class="option-content">
                  <div style="width: 200px">{{ optionItem.GoodName }}</div>
                  <div style="width: 200px">{{ optionItem.APCode }}</div>
                  <div>{{ optionItem.AutoSerise }}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!--        车系            -->
          <div class="div-table-cell" style="width: 16%">
            <el-input
              size="small"
              v-model="item.AutoSerise"
              v-if="item.IsNew"
              :disabled="type == 4"
              placeholder="车系"
              style="width: 100%"
            ></el-input>
            <el-select
              v-else
              :disabled="type == 4"
              :loading="loading"
              allow-create
              size="small"
              v-model="item.AutoSerise"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="车系"
              @visible-change="autoSeriseVisibleChange($event)"
              :remote-method="searchAutoSerie"
              style="width: 100%"
            >
              <el-option
                :loading="true"
                v-for="item in seriesList"
                :key="item.SeriesId"
                :label="item.SeriesName"
                :value="item.SeriesName"
              ></el-option>
            </el-select>
          </div>
          <!--        留余数            -->
          <div class="div-table-cell" style="width: 5%">
            <span>{{ item.OnlyLeft }}</span>
          </div>
          <!--        数量            -->
          <div class="div-table-cell" style="width: 8%">
            <el-input
              type="number"
              :ref="'count' + index"
              min="1"
              size="small"
              v-model="item.Count"
              @change="priceChange"
            ></el-input>
          </div>
          <!--        单位         -->
          <div class="div-table-cell" style="width: 5%">
            {{ item.Unit }}
          </div>
          <div class="div-table-cell" style="width: 5%">
            <span>
              {{ item.SalePrice }}
            </span>
          </div>
          <!--         采购价          -->
          <div class="div-table-cell" style="width: 8%">
            <el-input
              size="small"
              min="0"
              type="number"
              step="0.01"
              v-model="item.Price"
              @input="priceChange"
            ></el-input>
          </div>
          <!--         采购总价          -->
          <div class="div-table-cell" style="width: 8%">
            <span>{{
              item.Price * item.Count ? (item.Price * item.Count).toFixed(2) : 0
            }}</span>
          </div>
          <div class="div-table-cell" style="width: 10%">
            <el-button
              title="销售数据"
              size="mini"
              type="text"
              @click="showSaleStat(item)"
              >销售数据</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="showHistories(item.EntpTempGoodsId)"
              v-if="(!item.IsAlreadyPurchase && type == 4) || type == 3"
              >采购历史</el-button
            >
            <el-button
              size="mini"
              type="text"
              style="color: red"
              @click="showHistories(item.EntpTempGoodsId)"
              v-if="item.IsAlreadyPurchase && type == 4"
              >已采购</el-button
            >
          </div>
          <el-button
            class="less-btn"
            icon="el-icon-minus"
            circle
            @click="delItem(index)"
            v-if="type == 3"
          ></el-button>
        </div>
        <div class="div-table-row table-item">
          <div class="div-table-cell" style="width: 5%"></div>
          <div class="div-table-cell" style="width: 15%; flex-grow: 1"></div>
          <div class="div-table-cell" style="width: 15%"></div>
          <div class="div-table-cell" style="width: 16%"></div>
          <div class="div-table-cell" style="width: 5%">总数量</div>
          <div class="div-table-cell" style="width: 8%">
            <span>{{ allNum }}</span>
          </div>
          <div class="div-table-cell" style="width: 5%"></div>
          <div class="div-table-cell" style="width: 5%"></div>
          <div class="div-table-cell" style="width: 8%">合计</div>
          <div class="div-table-cell" style="width: 8%">
            <span>{{ allMoney.toFixed(3) }}</span>
          </div>
          <div class="div-table-cell" style="width: 10%"></div>
        </div>
      </div>
    </div>
    <div class="edit-ctn" v-else-if="type == 3">
      <!--      table title      -->
      <div class="div-table-row table-title">
        <div class="div-table-cell" style="width: 5%">
          <el-checkbox
            v-model="selectAll"
            @change="allSelectChange"
          ></el-checkbox>
          <el-checkbox-group v-model="selectList"></el-checkbox-group>
        </div>
        <div class="div-table-cell" style="width: 15%; flex-grow: 1">
          <span class="color-red">*</span>汽配编码
        </div>
        <div class="div-table-cell" style="width: 18%">
          <span class="color-red">*</span>配件名称
        </div>
        <div class="div-table-cell" style="width: 23%">
          <span class="color-red">*</span>车型
        </div>
        <div class="div-table-cell" style="width: 8%">数量</div>
        <div class="div-table-cell" style="width: 5%">单位</div>
        <div class="div-table-cell" style="width: 8%">
          <span class="color-red">*</span>采购价
        </div>
        <div class="div-table-cell" style="width: 8%">采购总价</div>
        <div class="div-table-cell" style="width: 10%"></div>
      </div>
      <div class="table-main">
        <div
          class="div-table-row table-item"
          v-for="(item, index) in dataList"
          :ref="'pj' + index"
          :key="index"
        >
          <div class="div-table-cell" style="width: 5%">
            <el-checkbox
              v-model="item.checked"
              @change="selectSingleItemChange(item)"
            ></el-checkbox>
          </div>
          <!--        编码            -->
          <div
            class="div-table-cell div-table-cell-code"
            style="width: 15%; flex-grow: 1"
            :class="{ 'check-code-class': item.CodeRepeat }"
          >
            <img
              src="../../../assets/images/info.png"
              alt
              title="配件信息"
              class="info-icon"
              @click="showAPMsgDialog(item.EntpTempGoodsId)"
            />
            <el-select
              :ref="'code' + index"
              :disabled="type == 4"
              :loading="loading"
              allow-create
              default-first-option
              size="small"
              v-model="item.APCode"
              value-key="APCode"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="汽配编码"
              @change="codeChange($event, index)"
              @visible-change="apCodeVisibleChange($event)"
              :remote-method="searchCode"
              style="width: 100%"
            >
              <el-option
                v-for="optionItem in codeList"
                :key="optionItem.EntpTempGoodsId"
                :data-msg="optionItem"
                :label="optionItem.APCode"
                :value="optionItem.APCode"
              >
                <div class="option-content">
                  <div style="width: 200px">{{ optionItem.APCode }}</div>
                  <div style="width: 200px">{{ optionItem.GoodName }}</div>
                  <div>{{ optionItem.AutoSerise }}</div>
                </div>
              </el-option>
            </el-select>
            <div v-if="item.State==1" class="row-delete">已删除</div>
          </div>
          <!--        名称            -->
          <div class="div-table-cell" style="width: 18%">
            <el-input
              size="small"
              v-model="item.GoodName"
              v-if="item.IsNew"
              :disabled="type == 4"
              placeholder="配件名称"
            ></el-input>
            <el-select
              v-else
              :disabled="type == 4"
              :loading="loading"
              allow-create
              size="small"
              v-model="item.GoodName"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="配件名称"
              @change="nameChange($event, index)"
              @visible-change="apNameVisibleChange($event)"
              :remote-method="searchName"
              style="width: 100%"
            >
              <el-option
                v-for="optionItem in nameList"
                :key="optionItem.EntpTempGoodsId"
                :data-msg="optionItem"
                :label="optionItem.GoodName"
                :value="optionItem.GoodName"
              >
                <div class="option-content">
                  <div style="width: 200px">{{ optionItem.GoodName }}</div>
                  <div style="width: 200px">{{ optionItem.APCode }}</div>
                  <div>{{ optionItem.AutoSerise }}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!--        车系            -->
          <div class="div-table-cell" style="width: 23%">
            <el-input
              size="small"
              v-model="item.AutoSerise"
              v-if="item.IsNew"
              :disabled="type == 4"
              placeholder="车系"
            ></el-input>
            <el-select
              v-else
              :disabled="type == 4"
              :loading="loading"
              allow-create
              size="small"
              v-model="item.AutoSerise"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="车系"
              @visible-change="autoSeriseVisibleChange($event)"
              :remote-method="searchAutoSerie"
              style="width: 100%"
            >
              <el-option
                :loading="true"
                v-for="item in seriesList"
                :key="item.SeriesId"
                :label="item.SeriesName"
                :value="item.SeriesName"
              ></el-option>
            </el-select>
          </div>
          <!--        数量            -->
          <div class="div-table-cell" style="width: 8%">
            <el-input
              type="number"
              :ref="'count' + index"
              min="1"
              size="small"
              v-model="item.Count"
              @change="priceChange"
            ></el-input>
          </div>
          <!--        单位         -->
          <div class="div-table-cell" style="width: 5%">
            {{ item.Unit }}
          </div>
          <!--         采购价          -->
          <div class="div-table-cell" style="width: 8%">
            <el-input
              size="small"
              min="0"
              type="number"
              step="0.01"
              v-model="item.Price"
              @input="priceChange"
            ></el-input>
          </div>
          <!--         采购总价          -->
          <div class="div-table-cell" style="width: 8%">
            <span>{{
              item.Price * item.Count ? (item.Price * item.Count).toFixed(2) : 0
            }}</span>
          </div>
          <div class="div-table-cell" style="width: 10%">
            <el-button
              title="销售数据"
              size="mini"
              type="text"
              @click="showSaleStat(item)"
              >销售数据</el-button
            >
            <el-button
              size="mini"
              @click="showHistories(item.EntpTempGoodsId)"
              v-if="(!item.IsAlreadyPurchase && type == 4) || type == 3"
              type="text"
              >采购历史</el-button
            >
            <el-button
              size="mini"
              style="color: red"
              @click="showHistories(item.EntpTempGoodsId)"
              v-if="item.IsAlreadyPurchase && type == 4"
              type="text"
              >已采购</el-button
            >
          </div>
          <el-button
            class="less-btn"
            icon="el-icon-minus"
            circle
            @click="delItem(index)"
            v-if="type == 3"
          ></el-button>
        </div>
        <div class="div-table-row table-item">
          <div class="div-table-cell" style="width: 5%"></div>
          <div class="div-table-cell" style="width: 15%; flex-grow: 1"></div>
          <div class="div-table-cell" style="width: 18%"></div>
          <div class="div-table-cell" style="width: 23%">总数量</div>
          <div class="div-table-cell" style="width: 8%">
            <span>{{ allNum }}</span>
          </div>
          <div class="div-table-cell" style="width: 5%"></div>
          <div class="div-table-cell" style="width: 8%">合计</div>
          <div class="div-table-cell" style="width: 8%">
            <span>{{ allMoney.toFixed(3) }}</span>
          </div>
          <div class="div-table-cell" style="width: 10%"></div>
        </div>
      </div>
    </div>
    <!--    新增供应商   -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增供应商"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div class="dialog-content" v-if="dialogVisible">
        <customerEdit
          ref="customerEdit"
          :type="customerEditType"
          source="2"
          @closeDialog="closeDialog"
        ></customerEdit>
      </div>
    </el-dialog>
    <!--   配件信息     -->
    <el-dialog
      :close-on-click-modal="false"
      title="配件信息"
      :visible.sync="APMsgVisible"
      width="1000px"
    >    
      <div v-if="APMsgVisible">    
        <APMsg
          :dialogFormVisible="APMsgVisible"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeAPMsgDialog"
        ></APMsg>
      </div>
    </el-dialog>     
    <!--   搜索配件    -->
    <el-dialog
      :close-on-click-modal="false"
      title="搜索配件"
      :visible.sync="searchVisible"
      width="1200px"
    >
      <div v-if="searchVisible">
        <searchAP
          :EntpCusId="submitData.EntpCusId"
          :SelectedData="selectedData"
          @closeDialog="closeSearchDialog"
        ></searchAP>
      </div>
    </el-dialog>
    <!--    采购历史    -->
    <el-dialog
      :close-on-click-modal="false"
      title="采购历史"
      :visible.sync="historyVisible"
      width="1200px"
    >
      <div v-if="historyVisible">
        <APPurchaseHistory
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeHistoryDialog"
        ></APPurchaseHistory>
      </div>
    </el-dialog>
    <!--   编辑订单信息    -->
    <el-dialog
      :close-on-click-modal="false"
      title="采购订单信息"
      :visible.sync="orderEditVisible"
      width="1200px"
    >
      <!--   form     -->
      <el-form
        :model="submitData"
        ref="formMsg"
        label-width="100px"
        style="width: 100%; padding-right: 30px; margin-top: 30px"
        :rules="rules"
        id="form-order"
      >
        <div class="form-main">
          <div class="form-left">
            <el-form-item label="供应商" prop="EntpCusId">
              <el-select
                v-model="submitData.EntpCusId"
                placeholder="请选择"
                filterable
                clearable
                remote
                style="width: 100%"
                :remote-method="searchCustomer"
                @change="customerChange($event)"
                @visible-change="customerVisibleChange($event)"
              >
                <el-option
                  v-for="optionItem in customerList"
                  :key="optionItem.EntpCusId"
                  :label="optionItem.EntpCusName"
                  :value="optionItem.EntpCusId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算方式" prop="PayType">
              <el-select
                v-model="submitData.PayType"
                placeholder="请选择"
                style="width: 100%"
                @visible-change="payVisibleChange($event)"
              >
                <el-option
                  v-for="item in payWayList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-center">
            <el-form-item label="业务员" prop="SId">
              <el-select
                v-model="submitData.SId"
                filterable
                clearable
                remote
                placeholder="请选择"
                style="width: 100%"
                @visible-change="siVisibleChange($event)"
              >
                <el-option
                  v-for="item in SIdList"
                  :key="item.EmployeeId"
                  :label="item.EmployeeName"
                  :value="item.EmployeeId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发货方式">
              <el-select
                v-model="submitData.ShipType"
                placeholder="请选择"
                style="width: 100%"
                @visible-change="sendWayVisibleChange($event)"
              >
                <el-option
                  v-for="item in DeliveryMethodList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-right">
            <el-form-item label="运输费用" prop="ShipAmount">
              <el-input
                type="number"
                step="0.01"
                min="0"
                v-model.trim="submitData.ShipAmount"
                @change="computeTotal"
              ></el-input>
            </el-form-item>
            <el-form-item label="总额">
              <el-input type="text" :disabled="true" :value="total"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-bottom">
          <el-form-item label="入仓仓库" prop="WarehouseId">
            <el-select
              v-model="submitData.WarehouseId"
              style="width: 66.66%"
              placeholder="请选择"
              filterable
              clearable
              @visible-change="warehouseVisibleChange($event)"
              @change="warehouseChange"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
                ><span style="float: left">{{ item.WarehouseName }}</span>
                <span
                  v-if="item.Type == 1"
                  style="float: right; color: #8492a6; font-size: 13px"
                  >（前置仓）</span
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库地址" prop="WarehouseAddr">
            <el-input
              v-if="canNotEditAddr"
              :title="submitData.WarehouseAddr"
              v-model="submitData.WarehouseAddr"
              :disabled="true"
              style="width: 66.66%"
            ></el-input>
            <el-input
              v-else
              v-model="submitData.WarehouseAddr"
              style="width: 66.66%"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              style="width: 66.66%"
              v-model.trim="submitData.Remark"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div
        class="dialog-footer"
        style="text-align: right; padding-right: 30px; margin-bottom: 30px"
      >
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click="addCustomer(1)"
          v-if="(type == 3 || type == 4) && permission.addSupplier"
          >{{ permission.addSupplier }}</el-button
        >
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click="submitPurchaseForm(1, 1)"
          v-if="permission.submitOrder"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="SaleDialogTitle"
      :visible.sync="showSaleStatDialog"
      :append-to-body="true"
      width="1300px"
    >
      <div v-if="showSaleStatDialog">
        <saleStat
          @closeDialog="closeSaleStatDialog"
          :APId="this.APId"
        ></saleStat>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import customerEdit from "@/components/business/customerManage/customerEdit";
import searchAP from "@/components/common/searchAP";
import APMsg from "@/components/common/APMsg";
import APPurchaseHistory from "@/components/common/APPurchaseHistory";
import saleStat from "@/components/business/revenue/apSaleStat";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    customerEdit,
    searchAP,
    APMsg,
    APPurchaseHistory,
    breadcrumb,
    saleStat,
  },
  data() {
    let checkPhone = this.$util.checkPhone;
    let checkPositive = this.$util.checkPositive;
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg: userMsg,
      customerEditType: 1,
      dialogVisible: false,
      APMsgVisible: false,
      searchVisible: false,
      orderEditVisible: false,
      historyVisible: false,
      EntpTempGoodsIdEdit: "",
      EntpId: userMsg.EntpId,
      canRequest: true,
      dataReadonly: false,
      allNum: 1,
      allMoney: 0,
      loading: false,
      selectAll: false,
      total: 0,
      showSaleStatDialog: false,
      SaleDialogTitle: "",
      canNotEditAddr: false,
      SIdList: [
        {
          EmployeeId: userMsg.EmployeeId,
          EmployeeName: userMsg.EmployeeName,
        },
      ],
      submitData: {
        SId: userMsg.EmployeeId,
        SubmissionState: false,
        UserId: userMsg.EmployeeId,
        ShipAmount: "",
        EntpCusOId: "", //转采购单时，需要将销售订单Id传值
        Sources: 0, //采购单来源 0 是直接采购；1 是库存需求转化的采购订单；2 销售单转化采购订单；3 询价转化的采购订单
        EntpCusId: "",
        PayType: null,
        ShipType: null,
        AddressId: null,
        PhoneNum: "",
        Remark: "",
        DetailList: [],
        Bank: "",
        AccountName: "",
        Account: "",
        WarehouseId: "",
        WarehouseAddr: "",
      },
      Limit: 10,
      customerList: [],
      DeliveryMethodList: [], // 发货方式列表
      payWayList: [],
      bankList: [],
      accountList: [],
      accountNameList: [],
      addressList: [],
      codeList: [],
      nameList: [],
      seriesList: [],
      selectList: [],
      dataList: [],
      unitList: [],
      type: 0, //  3 库存采购； 4 销售转采购
      id: "",
      pageTitle: "",
      rules: {
        EntpCusId: [
          {
            required: true,
            message: "填选择供应商",
            trigger: "change",
          },
        ],
        PhoneNum: [
          {
            required: true,
            validator: checkPhone,
            trigger: "blur",
          },
          {
            required: true,
            message: "请填写手机号",
            trigger: "blur",
          },
        ],
        AddressId: [
          {
            required: true,
            message: "填写收货地址",
            trigger: "blur",
          },
        ],
        ShipAmount: [
          {
            validator: checkPositive,
            trigger: "blur",
          },
        ],
        PayType: [
          {
            required: true,
            message: "填写结算方式",
            trigger: "blur",
          },
        ],
        SId: [
          {
            required: true,
            message: "填选择业务员",
            trigger: "change",
          },
        ],
        WarehouseId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "blur",
          },
        ],
        WarehouseAddr: [
          { required: true, message: "请填写仓库地址", trigger: "blur" },
        ],
      },
      permission: {},
      warehouseList: [],
      selectedData:[],
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.id = this.$route.query.id;
    this.permission = this.$util.getPermission("supplierBuyOrder");

    if (this.type == 3) {
      this.pageTitle = "库存采购";
    } else if (this.type == 4) {
      this.pageTitle = "转为采购单";
    }

    this.initDataList();
  },
  methods: {
    initDataList() {
      if (this.type == 3) {
        let _dataList = this.$util.getLocalStorage("QuickBuyAP");
        for (let i = 0; i < _dataList.length; i++) {
          this.dataList.push({
            EntpTempGoodsId: _dataList[i].EntpTempGoodsId,
            APCode: _dataList[i].APCode,
            GoodName: _dataList[i].GoodName,
            AutoSerise: _dataList[i].AutoSerise,
            Count:
              _dataList[i].RemainingInventoryQuantity < 0
                ? Math.abs(_dataList[i].RemainingInventoryQuantity)
                : 0,
            Price: _dataList[i].CostPrice, //这里是用商品的成本价作为采购价
            Unit: _dataList[i].Unit,
            Remark: "",
            CodeRepeat: false,
            OnlyLeft: _dataList[i].RemainingInventoryQuantity,
            SalePrice: "",
            State: 0
          });
        }
        this.priceChange();
      } else if (this.type == 4) {
        this.getSaleOrder();
      }
    },
    // 勾选单个商品
    selectSingleItemChange(item) {
      this.computeCheck();
    },
    //全部选中事件
    allSelectChange() {
      let that = this;
      let _dataList = that.dataList;
      if (that.selectAll) {
        for (let i = 0; i < _dataList.length; i++) {
          _dataList[i].checked = true;
        }
      } else {
        for (let i = 0; i < _dataList.length; i++) {
          _dataList[i].checked = false;
        }
      }
      that.computeCheck();
    },
    computeCheck() {
      let _data = this.dataList;
      let _selectList = [];
      let _selectAll = true;
      for (let n = 0; n < _data.length; n++) {
        if (_data[n].checked) {
          _selectList.push(_data[n]);
        } else {
          _selectAll = false;
        }
      }
      this.selectAll = _selectAll;
      this.selectList = _selectList;
    },
    getSaleOrder() {
      this.dataList = [];
      this.$util
        .axiosGet({
          url:
            "/api/EntpSaleOrder/GetEnterpriseCustomerSaleOrderContainLeft",
          data: {
            EntpCusOId: this.id,
            EntpId: this.EntpId,
          },
        })
        .then((res) => {
          let _dataList = res.data.DetailList;
          for (let i = 0; i < _dataList.length; i++) {
            this.dataList.push({
              EntpTempGoodsId: _dataList[i].EntpTempGoodsId,
              APCode: _dataList[i].APCode,
              GoodName: _dataList[i].GoodName,
              AutoSerise: _dataList[i].AutoSerise,
              Count: _dataList[i].Count,
              Price: _dataList[i].CostPrice, //这里是用商品的成本价作为采购价
              Unit: _dataList[i].Unit,
              Remark: "",
              CodeRepeat: false,
              Inventory: _dataList[i].Inventory,
              OnlyLeft: _dataList[i].OnlyLeft,
              IsAlreadyPurchase: _dataList[i].IsAlreadyPurchase,
              SalePrice: _dataList[i].Price, //销售价
              State: _dataList[i].State
            });
          }
          this.priceChange();
        });
    },
    showSubmitForm() {
      //还要判断是否有选中的配件
      let that = this;
      let _total = 0;
      if (that.selectList.length == 0) {
        that.$util.warningMsg("请选择配件再进行采购");
        that.orderEditVisible = false;
      } else {
        that.selectList.forEach((item) => {
          _total += Number(item.Price) * Number(item.Count);
        });
        that.total = _total.toFixed(2);
        that.orderEditVisible = true;
      }

      let _dataList = that.selectList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          that.$util.warningMsg("请填写配件编码");
          that.orderEditVisible = false;
        }
        if (!_dataList[i].GoodName) {
          that.$util.warningMsg("请填写配件名称");
          that.orderEditVisible = false;
        }
        if(_dataList[i].State != 0){
          this.$util.warningMsg("商品【"+_dataList[i].GoodName+"（"+_dataList[i].APCode+"）"+"】已删除");
          that.orderEditVisible = false;
          return;
        }
        if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
          that.$util.warningMsg("请填写正确的配件数量");
          that.orderEditVisible = false;
        }
        if (!_dataList[i].AutoSerise) {
          that.$util.warningMsg("请填写车型");
          that.orderEditVisible = false;
        }
        if (!_dataList[i].Unit) {
          that.$util.warningMsg("请填写单位");
          that.orderEditVisible = false;
        }
        if (!_dataList[i].Price || _dataList[i].Price < 0) {
          that.$util.warningMsg("请填写正确的采购价");
          that.orderEditVisible = false;
        }
      }
    },
    computeTotal(val) {
      let that = this;
      let _total = that.total;

      _total = Number(val) + Number(_total);

      that.total = _total.toFixed(2);
    },
    getSIdList() {
      this.$util.getPurchaserList().then((data) => {
        this.SIdList = data;
      });
    },
    // getConfigData() {
    //   this.$util.getConfigData("Unit").then((res) => {
    //     this.unitList = res;
    //   });
    // },
    // 历史销售
    showHistories(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.historyVisible = true;
      }
    },
    closeHistoryDialog() {
      this.historyVisible = false;
    },
    // 搜索
    showSearch() {
      if (this.dataList.length > 0) {
        this.selectedData = [];
        this.dataList.forEach((item) => {
          if(item.EntpTempGoodsId)
           this.selectedData.push(item.EntpTempGoodsId);
        });
      }
      this.searchVisible = true;
    },
    closeSearchDialog(items) {
      let that = this;
      let itemList = [...items];
      if (itemList.length == 0) {
        that.searchVisible = false;
        return;
      }
      let newGoodsList = [];
      for (let i = 0; i < itemList.length; i++) {
        let item = itemList[i];
        let goods = that.dataList.find((e) => item.APCode == e.APCode);
        if (!goods) {
          let newGoods = {
            EntpTempGoodsId: item.EntpTempGoodsId,
            APCode: item.APCode,
            GoodName: item.GoodName,
            AutoSerise: item.AutoSerise,
            Count: 1,
            Price: item.Price ? item.Price : 0,
            Unit: item.Unit,
            Remark: item.Remark,
            CodeRepeat: false,
            State: 0
          };
          newGoodsList.push(newGoods);
        }
      }
      that.dataList = that.dataList.concat(newGoodsList);

      that.priceChange();
      that.searchVisible = false;
      that.$nextTick(() => {
        if (that.$refs["count" + (that.dataList.length - 1).toString()]) {
          that.$refs[
            "count" + (that.dataList.length - 1).toString()
          ][0].focus();
        }
      });
    },
    // 配件信息
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog(edit) {
      this.APMsgVisible = false;
    },
    checkCodeRepeat() {
      let repeatIndexs = [];
      let obj = {};
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        _dataList[i].CodeRepeat = false;
        if (!obj[_dataList[i].APCode]) {
          obj[_dataList[i].APCode] = [i];
        } else {
          obj[_dataList[i].APCode].push(i);
        }
      }
      for (let key in obj) {
        if (obj[key].length >= 2) {
          repeatIndexs = [...repeatIndexs, ...obj[key]];
        }
      }
      for (let j = 0; j < repeatIndexs.length; j++) {
        this.dataList[repeatIndexs[j]].CodeRepeat = true;
      }
    },
    // 数量或者价格变动
    priceChange() {
      let DetailList = this.dataList;
      let _allNum = 0;
      let _allMoney = 0;
      for (let i = 0; i < DetailList.length; i++) {
        _allNum += Number(DetailList[i].Count);
        _allMoney += Number(
          DetailList[i].Count * DetailList[i].Price
            ? (DetailList[i].Count * DetailList[i].Price).toFixed(2)
            : 0
        );
      }
      this.allMoney = _allMoney;
      this.allNum = _allNum;
      this.dataList = DetailList;
    },
    closeDialog(edit) {
      this.dialogVisible = false;
      if (edit) {
        this.searchCustomer();
      }
    },
    addCustomer(type) {
      this.customerEditType = type;
      this.dialogVisible = true;
    },
    // 提交采购单
    submitPurchaseForm(type, SubmissionState) {
      if (!this.canRequest) {
        return false;
      }
      this.$refs["formMsg"].validate((valid) => {
        if (valid && this.canRequest) {
          let _dataList = this.selectList;

          for (let i = 0; i < _dataList.length; i++) {
            if (!_dataList[i].APCode) {
              this.$util.warningMsg("请填写配件编码");
              return;
            }
            if (!_dataList[i].GoodName) {
              this.$util.warningMsg("请填写配件名称");
              return;
            }
            if (!_dataList[i].AutoSerise) {
              this.$util.warningMsg("请填写车型");
              return;
            }
            if (!this.submitData.EntpCusId) {
              this.$util.warningMsg("填选择供应商");
              return;
            }
            if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
              this.$util.warningMsg("请填写正确的配件数量");
              return;
            }
            if (!_dataList[i].Unit) {
              this.$util.warningMsg("请填写单位");
              return;
            }
            if (!_dataList[i].Price || _dataList[i].Price < 0) {
              this.$util.warningMsg("请填写正确的采购价");
              return;
            }
          }
          this.submitData.DetailList = _dataList;

          this.canRequest = false;
          if (SubmissionState) {
            this.submitData.SubmissionState = SubmissionState;
          }

          let url = "";
          // 先验证是否已经有了该销售单转的同一个供应商的采购单
          if (this.type == 4) {
            this.submitData.EntpCusOId = this.id;
            this.submitData.Sources = 2;
            this.$util
              .axiosGet({
                url:
                  "/api/EntpPurchaseOrder/VerifySubmitEntpTransPurchaseOrder",
                data: {
                  SaleOrderId: this.id,
                  EntpId: this.EntpId,
                  EntpCusId: this.submitData.EntpCusId,
                },
                hideLoading: true,
              })
              .then((res) => {
                let result = res.data;
                if (result) {
                  url =
                    "/api/EntpPurchaseOrder/SaveEntpPurOrder";
                  this.$util
                    .axiosPost({
                      url: url,
                      data: this.submitData,
                    })
                    .then(() => {
                      this.$util.successMsg("转为采购单成功");
                      this.selectAll = false;
                      this.selectList = [];
                      this.getSaleOrder();
                      this.orderEditVisible = false;
                      this.canRequest = true;
                    })
                    .catch(() => {
                      this.canRequest = true;
                    });
                } else {
                  //由于不信任，前任前端封装的代码，所以用原生的ele的提示 by Vam
                  this.$confirm(
                    "已有该供应商的采购单，是否合并两张采购单?",
                    "提示",
                    {
                      confirmButtonText: "合并",
                      cancelButtonText: "新建",
                      type: "warning",
                      center: true,
                      distinguishCancelAndClose: true,
                      closeOnClickModal: false,
                    }
                  )
                    .then(() => {
                      url =
                        "/api/EntpPurchaseOrder/AddToEntpExistPurOrder";
                      this.$util
                        .axiosPost({
                          url: url,
                          data: this.submitData,
                        })
                        .then(() => {
                          this.$util.successMsg("合并采购单成功");
                          this.selectAll = false;
                          this.selectList = [];
                          this.getSaleOrder();
                          this.orderEditVisible = false;
                          this.canRequest = true;
                        })
                        .catch(() => {
                          this.canRequest = true;
                        });
                    })
                    .catch((action) => {
                      if (action !== "cancel") return;
                      url =
                        "/api/EntpPurchaseOrder/SaveEntpPurOrder";
                      this.$util
                        .axiosPost({
                          url: url,
                          data: this.submitData,
                        })
                        .then(() => {
                          this.$util.successMsg("新建采购单成功");
                          //这里需要做一件事，重新刷新列表
                          this.selectAll = false;
                          this.selectList = [];
                          this.getSaleOrder();
                          this.orderEditVisible = false;
                          this.canRequest = true;
                        })
                        .catch(() => {
                          this.canRequest = true;
                        });
                    });
                }
              })
              .catch(() => {
                this.canRequest = true;
                this.$util.warningMsg("验证出现异常，请联系技术人员");
              });
          } else if (this.type == 3) {
            this.submitData.Sources = 1;
            url =
              "/api/EntpPurchaseOrder/SaveEntpPurOrder";
            this.$util
              .axiosPost({
                url: url,
                data: this.submitData,
              })
              .then(() => {
                this.$util.successMsg("库存采购单创建成功");
                //清除参数缓存
                this.$util.clearLocalStorage("QuickBuyAP");
                setTimeout(() => {
                  this.canRequest = true;
                  window.history.go(-1);
                }, 2000);
              })
              .catch(() => {
                this.canRequest = true;
              });
          }
        }
      });
    },
    // 删除某行
    delItem(index) {
      if (this.dataList.length != 1) {
        this.dataList.splice(index, 1);
      }
      this.priceChange();
    },
    // 添加一行
    addItem() {
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          this.$util.warningMsg("请填写配件编码");
          return;
        }
        if (!_dataList[i].GoodName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }
        if (!_dataList[i].AutoSerise) {
          this.$util.warningMsg("请填写车型");
          return;
        }
        if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
          this.$util.warningMsg("请填写正确的配件数量");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("请填写单位");
          return;
        }
        if (!_dataList[i].Price || _dataList[i].Price < 0) {
          this.$util.warningMsg("请填写正确的采购价");
          return;
        }
      }
      this.dataList.push({
        EntpTempGoodsId: "",
        APCode: "",
        GoodName: "",
        AutoSerise: "",
        Count: "1",
        Price: "0",
        Unit: "",
        Remark: "",
        CodeRepeat: false,
      });
      this.priceChange();
    },
    // 搜索顾客
    searchCustomer(key) {
      this.loading = true;
      this.customerList = [];
      this.$util.searchSupplier(key).then((data) => {
        this.loading = false;
        this.customerList = this.$util.uniqueArr(this.customerList, data);
      });
    },
    // 获取地址
    getAddressList() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpInfoManagement/GetAddressList",
          data: {
            Page: 1,
            Limit: 999,
            EntpId: this.EntpId,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.loading = false;
          let data = res.data;
          let _addressList = [];
          for (let i = 0; i < data.length; i++) {
            _addressList.push({
              Text: `${data[i].Province}${data[i].City}${data[i].District}${data[i].Addr}`,
              Value: data[i].Id,
            });
          }
          this.addressList = _addressList;
        });
    },
    // 搜索汽配编码
    searchCode(key) {
      this.loading = true;
      this.$util
        .axiosGet({
          url:
            // "/api/EntpQuotationOrder/GetEnterpriseFastPartList",
            "/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder",
          data: {
            APCode: key,
            Limit: this.Limit,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.loading = false;
          this.codeList = res.data;
        });
    },
    // 搜索名称
    searchName(key) {
      this.loading = true;
      this.$util
        .axiosGet({
          url:
            // "/api/EntpQuotationOrder/GetEnterpriseFastPartList",
            "/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder",
          data: {
            GoodName: key,
            Limit: this.Limit,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.loading = false;
          this.nameList = res.data;
        });
    },
    // 搜车系
    searchAutoSerie(key) {
      this.loading = true;
      this.$util.searchAutoSerie(key).then((data) => {
        this.seriesList = data;
        this.loading = false;
      });
    },

    //  结算方式
    getPay() {
      this.$util.getPay().then((data) => {
        this.payWayList = data;
      });
    },
    // 获取发货方式
    getSendWay() {
      this.$util.getSendWay().then((data) => {
        this.DeliveryMethodList = data;
      });
    },
    // 名称改变
    nameChange(value, index) {
      this.searchName();
      let _list = this.nameList;
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].GoodName == value) {
          if (!this.dataList[index].APCode) {
            this.dataList[index].APCode = _list[i].APCode;
            this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
          }
          this.dataList[index].GoodName = _list[i].GoodName;
          this.dataList[index].Price = _list[i].CostPrice;
          this.dataList[index].Unit = _list[i].Unit;
          this.dataList[index].AutoSerise = _list[i].AutoSerise;
        }
      }
      this.priceChange();
    },
    // 编码改变
    codeChange(value, index) {
      let isNew = true;
      this.checkCodeRepeat();
      this.searchCode();
      let _list = this.codeList;
      if (!value) {
        this.dataList[index].IsNew = false;
      }
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].APCode == value) {
          this.dataList[index].APCode = _list[i].APCode;
          this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
          this.dataList[index].GoodName = _list[i].GoodName;
          this.dataList[index].Price = _list[i].CostPrice;
          this.dataList[index].Unit = _list[i].Unit;
          this.dataList[index].AutoSerise = _list[i].AutoSerise;
          this.dataList[index].IsNew = false;
          isNew = false;
        }
      }
      if (isNew && value) {
        let that = this;
        this.$util.elConfirm({
          content: "要创建一个新配件吗？",
          noMsg: true,
          confirm() {
            that.dataList[index].EntpTempGoodsId = "";
            that.dataList[index].Price = 0;
            that.dataList[index].Inventory = 0;
            that.dataList[index].IsNew = true;
            that.$nextTick(() => {
              that.$refs["code" + index][0].blur();
            });
            that.$util
              .axiosGet({
                url: "/api/EntpGoods/GetPart",
                data: {
                  APCode: value,
                },
                hideLoading: true,
              })
              .then((res) => {
                if (res.data) {
                  let data = res.data;
                  that.dataList[index].APCode = data.APCode;
                  that.dataList[index].AutoSerise = data.AutoSerise;
                  that.dataList[index].GoodName = data.GoodName;
                  that.dataList[index].Unit = data.Unit;
                }
              });
          },
        });
      }
      this.priceChange();
    },
    // 供应商改变
    customerChange(value) {
      this.submitData.Bank = "";
      this.submitData.AccountName = "";
      this.submitData.Account = "";
    },
    //单位下拉框显示时触发event
    // unitVisibleChange(event) {
    //   let that = this;
    //   if (event) {
    //     if (that.unitList.length == 0) that.getConfigData();
    //   }
    // },
    //当供应商下拉框出现时触发
    customerVisibleChange(event) {
      let that = this;
      if (event) {
        that.searchCustomer();
      }
    },
    //当汽配件编码下拉框出现时触发
    apCodeVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.codeList.length == 0) that.searchCode();
      }
    },
    //当汽配件名称下拉框出现时触发
    apNameVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.nameList.length == 0) that.searchName();
      }
    },
    //当车系下拉框出现时触发
    autoSeriseVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.seriesList.length == 0) that.searchAutoSerie();
      }
    },
    //当业务员下拉框出现时触发
    siVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.SIdList.length <= 1) that.getSIdList();
      }
    },
    addressVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.addressList.length <= 1) that.getAddressList();
      }
    },
    //结算方式下拉框显示时触发event
    payVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.payWayList.length == 0) that.getPay();
      }
    },
    //当发货方式下拉框出现时触发
    sendWayVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.DeliveryMethodList.length == 0) that.getSendWay();
      }
    },
    // 获取仓库列表
    getWarehouse() {
       this.$util.getWarehouse(1).then((data) => {
        this.warehouseList = data;
      });
    },
    warehouseVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.warehouseList.length <= 1) that.getWarehouse();
      }
    },
    warehouseChange(val) {
      let that = this;
      if (val) {
        for (let i = 0; i < that.warehouseList.length; i++) {
          if (val == that.warehouseList[i].WarehouseId) {
            that.submitData.WarehouseAddr = that.warehouseList[i].Address;
            if (that.warehouseList[i].Type == 1) this.canNotEditAddr = true;
            else this.canNotEditAddr = false;
            return;
          }
        }
      }
    },
    showSaleStat(row) {
      if (row) {
        this.SaleDialogTitle =
          "销售数据：" + row.APCode + " " + row.GoodName + " " + row.AutoSerise;
        this.APId = row.EntpTempGoodsId;
        this.showSaleStatDialog = true;
      }
    },
    closeSaleStatDialog() {
      this.showSaleStatDialog = false;
    },
  },
};
</script>
<style lang="less"
  scoped>
.payment-tip {
  position: absolute;
  left: 0;
  bottom: -18px;
  line-height: 1;
  font-size: 12px;
  color: @font4Color;
}

.form-main {
  display: flex;

  > div {
    width: 33.33%;
  }
}

.inventory-title {
  line-height: 1.2;
  flex-direction: column;

  > div:nth-child(1) {
    width: 100%;
    border-bottom: 1px solid @border3Color;
  }

  > div:nth-child(2) {
    width: 100%;
    display: flex;

    > div {
      width: 33.33%;
    }
  }
}

.form-section {
  display: flex;
}

.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}

.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}

.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 20px;
  margin-bottom: 20px;
}

.option-content {
  display: flex;
  line-height: 30px;
}

.add-btn {
  position: absolute;
  right: -40px;
  bottom: 0;
}

.less-btn {
  position: absolute;
  right: -40px;
  top: 0;
  z-index: 2;
}

.business-content-main {
  padding-right: 80px;
}

.table-main {
  position: relative;
}

.image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px dashed @border3Color;
}

.table-title {
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}

.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.div-table-cell-code {
  position: relative;
  .row-delete {
    position: absolute;
    padding: 1px 6px;
    top: 0;
    right: 0;
    color: #fff;
    background: #FFCC66;
    border-radius: 12.5px;
  }
}

.table-item {
  height: 50px;
  position: relative;
}

.div-table-row {
  overflow: inherit;
}
.check-code-class {
  .el-input__inner {
    border: 1px solid #f56c6c;
  }
}
</style>